// @flow

import {
  getShippingMethodApi,
  updatedShippingMethodEnabledApi,
  addShippingCountriesApi,
  updateShippingMethodActiveApi,
  // FLAT RATE
  getFlatRateApi,
  updateFlatRateApi,
  deleteFlatRateApi,
  saveFlatRateApi,
  // SHIPPING ADVANCED
  saveShippingAdvancedApi,
  getShippingAdvancedApi,
  updateShippingAdvancedApi,
  deleteShippingAdvancedApi,
  // SHIPING STANDARD
  saveShippingStandardApi,
  getShippingStandardApi,
  updateShippingStandardApi,
  deleteShippingStandardApi,
  endpoints,
} from './api';
import {ofType, ActionsObservable} from 'redux-observable';
import {map, switchMap} from 'rxjs/operators';
import {
  ActionCreator,
  createReducer,
  buildCatchError,
} from '../../../../store/utils';
import {buildRoute} from '../../../../http';

import type {Action} from '../../../../store/utils';
import type {
  Country,
  ShippingAdvancedRate,
  ShippingDataManual,
  ShippingDataAdvanced,
  ShippingDataStandard,
  ShippingStandarRate,
  ShippingMethodLogistic,
} from '../../../../entities';

type ShippingMethodEnabled = {
  enabled: boolean,
  storeShippingMethodSettings: {
    storeShippingMethodType: string,
  },
};

export type ShippingConfigAction = Action & {
  error?: string,
  shippingCountries?: Country[],
  shippingMethods?: ShippingMethodEnabled,
  shippingMethodActive?: ShippingMethodEnabled,
  enabled?: boolean,

  flatRateId?: string,
};

export type ShippingConfigState = {
  shippingMethods?: ShippingMethodLogistic,

  isFetchingShippingMethods?: boolean,
  fetchingShippingSuccess?: boolean,
  fetchingShippingError?: boolean,

  isSaving?: boolean,
  savingShippingSuccess?: boolean,
  savingShippingError?: boolean,

  availableShippingCountries?: Country[],

  shippingDataEstandar?: ShippingDataStandard,
  shippingDataAdvanced?: ShippingDataAdvanced,
  shippingDataManual?: ShippingDataManual,

  messageError?: string,
  flatRate?: ShippingDataManual,
  advancedRate?: ShippingAdvancedRate,
  standardRate?: ShippingStandarRate,

  locationsSelected?: string[],
};

export const initialState: ShippingConfigState = {
  shippingMethods: undefined,
  isFetchingShippingMethods: false,
  availableShippingCountries: [],
};

export class FetchShippingMethodsEnabled extends ActionCreator<ShippingConfigAction> {}
export class FetchShippingMethodsEnabledSuccess extends ActionCreator<ShippingConfigAction> {}
export class FetchShippingMethodsEnabledError extends ActionCreator<ShippingConfigAction> {}

export class SaveShippingMethodActive extends ActionCreator<ShippingConfigAction> {}
export class SaveShippingMethodActiveSuccess extends ActionCreator<ShippingConfigAction> {}
export class SaveShippingMethodActiveError extends ActionCreator<ShippingConfigAction> {}

export class FetchShippingMethod extends ActionCreator<ShippingConfigAction> {}
export class FetchShippingMethodSuccess extends ActionCreator<ShippingConfigAction> {}
export class FetchShippingMethodError extends ActionCreator<ShippingConfigAction> {}

export class SaveShippingCountries extends ActionCreator<ShippingConfigAction> {}
export class SaveShippingCountriesSuccess extends ActionCreator<ShippingConfigAction> {}
export class SaveShippingCountriesError extends ActionCreator<ShippingConfigAction> {}

// RESET
export class ResetState extends ActionCreator<ShippingConfigAction> {}

// FLATE RATE
export class SaveFlatRate extends ActionCreator<ShippingConfigAction> {}
export class SaveFlatRateSuccess extends ActionCreator<ShippingConfigAction> {}
export class SaveFlatRateError extends ActionCreator<ShippingConfigAction> {}

export class FetchFlatRate extends ActionCreator<ShippingConfigAction> {}
export class FetchFlatRateSuccess extends ActionCreator<ShippingConfigAction> {}
export class FetchFlatRateError extends ActionCreator<ShippingConfigAction> {}

export class EditFlatRate extends ActionCreator<ShippingConfigAction> {}
export class EditFlatRateSuccess extends ActionCreator<ShippingConfigAction> {}
export class EditFlatRateError extends ActionCreator<ShippingConfigAction> {}

export class DeleteFlatRate extends ActionCreator<ShippingConfigAction> {}
export class DeleteFlatRateSuccess extends ActionCreator<ShippingConfigAction> {}
export class DeleteFlatRateError extends ActionCreator<ShippingConfigAction> {}

// SHIPPING ADVANCED
export class SaveLocationsSelected extends ActionCreator<ShippingConfigAction> {}
export class SaveShippingAdvanced extends ActionCreator<ShippingConfigAction> {}
export class SaveShippingAdvancedSuccess extends ActionCreator<ShippingConfigAction> {}
export class SaveShippingAdvancedError extends ActionCreator<ShippingConfigAction> {}

export class FetchShippingAdvanced extends ActionCreator<ShippingConfigAction> {}
export class FetchShippingAdvancedSuccess extends ActionCreator<ShippingConfigAction> {}
export class FetchShippingAdvancedError extends ActionCreator<ShippingConfigAction> {}

export class EditShippingAdvanced extends ActionCreator<ShippingConfigAction> {}
export class EditShippingAdvancedSuccess extends ActionCreator<ShippingConfigAction> {}
export class EditShippingAdvancedError extends ActionCreator<ShippingConfigAction> {}

export class DeleteShippingAdvanced extends ActionCreator<ShippingConfigAction> {}
export class DeleteShippingAdvancedSuccess extends ActionCreator<ShippingConfigAction> {}
export class DeleteShippingAdvancedError extends ActionCreator<ShippingConfigAction> {}

export class UpdateAllowOrderOutsideDeliveryZone extends ActionCreator<ShippingConfigAction> {}
export class UpdateAllowOrderOutsideDeliveryZoneSuccess extends ActionCreator<ShippingConfigAction> {}
export class UpdateAllowOrderOutsideDeliveryZoneError extends ActionCreator<ShippingConfigAction> {}

export class ClearAllLocationsSelected extends ActionCreator<ShippingConfigAction> {}

// SHIPPING STANDARD
export class SaveShippingStandard extends ActionCreator<ShippingConfigAction> {}
export class SaveShippingStandardSuccess extends ActionCreator<ShippingConfigAction> {}
export class SaveShippingStandardError extends ActionCreator<ShippingConfigAction> {}

export class FetchShippingStandard extends ActionCreator<ShippingConfigAction> {}
export class FetchShippingStandardSuccess extends ActionCreator<ShippingConfigAction> {}
export class FetchShippingStandardError extends ActionCreator<ShippingConfigAction> {}

export class EditShippingStandard extends ActionCreator<ShippingConfigAction> {}
export class EditShippingStandardSuccess extends ActionCreator<ShippingConfigAction> {}
export class EditShippingStandardError extends ActionCreator<ShippingConfigAction> {}

export class DeleteShippingStandard extends ActionCreator<ShippingConfigAction> {}
export class DeleteShippingStandardSuccess extends ActionCreator<ShippingConfigAction> {}
export class DeleteShippingStandardError extends ActionCreator<ShippingConfigAction> {}

export const actions = {
  updateEnabledShippingMethods: (payload: ShippingConfigAction) =>
    new FetchShippingMethodsEnabled(payload),
  getEnabledShippingMethods: () => new FetchShippingMethod(),
  // saveShippingMethod: (payload: ShippingConfigAction) =>
  //   new SaveShippingMethod(payload),
  saveShippingCountries: (payload: ShippingConfigAction) =>
    new SaveShippingCountries(payload),
  saveShippingMethodActive: (payload: ShippingConfigAction) =>
    new SaveShippingMethodActive(payload),

  // RESET
  resetState: () => new ResetState(),

  // FLAT RATE
  saveFlatRate: (payload: ShippingConfigAction) => new SaveFlatRate(payload),
  fetchFlatRate: (payload: ShippingConfigAction) => new FetchFlatRate(payload),
  editFlatRate: (payload: ShippingConfigAction) => new EditFlatRate(payload),
  deleteFlatRate: (payload: ShippingConfigAction) =>
    new DeleteFlatRate(payload),

  // SHIPPING ADVANCED
  saveLocationsSelected: (payload: ShippingConfigAction) =>
    new SaveLocationsSelected(payload),
  saveShippingAdvanced: (payload: ShippingConfigAction) =>
    new SaveShippingAdvanced(payload),
  fetchShippingAdvanced: (payload: ShippingConfigAction) =>
    new FetchShippingAdvanced(payload),
  editShippingAdvanced: (payload: ShippingConfigAction) =>
    new EditShippingAdvanced(payload),
  deleteShippingAdvanced: (payload: ShippingConfigAction) =>
    new DeleteShippingAdvanced(payload),
  updateAllowOrderOutsideDeliveryZone: (payload: ShippingConfigAction) =>
    new UpdateAllowOrderOutsideDeliveryZone(payload),
  clearAllLocationsSelected: (payload: ShippingConfigAction) =>
    new ClearAllLocationsSelected(payload),

  // SHIPPING STANDARD
  saveShippingStandard: (payload: ShippingConfigAction) =>
    new SaveShippingStandard(payload),
  fetchShippingStandard: (payload: ShippingConfigAction) =>
    new FetchShippingStandard(payload),
  editShippingStandard: (payload: ShippingConfigAction) =>
    new EditShippingStandard(payload),
  deleteShippingStandard: (payload: ShippingConfigAction) =>
    new DeleteShippingStandard(payload),
};

export default createReducer<ShippingConfigState>(initialState, {
  [FetchShippingMethod.type]: (state: ShippingConfigState) => ({
    ...state,
    isFetchingShippingMethods: true,
    fetchingShippingSuccess: false,
    fetchingShippingError: false,
  }),
  [FetchShippingMethodSuccess.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => {
    const dataShippingMethods = {
      enabled: action.shippingMethods.enabled,
      storeShippingMethodSettings: {
        storeShippingMethodType: action.shippingMethods.storeShippingMethodType,
      },
    };

    const shippingDataEstandar =
      action.shippingMethods.storeShippingMethodStandardMethods;
    const shippingDataAdvanced =
      action.shippingMethods.storeShippingMethodAdvancedSetting;
    const shippingDataManual = action.shippingMethods.flatRates;

    return {
      ...state,
      shippingMethods: dataShippingMethods,
      shippingDataEstandar: shippingDataEstandar,
      shippingDataAdvanced: shippingDataAdvanced,
      shippingDataManual: shippingDataManual,
      availableShippingCountries:
        action.shippingMethods.availableShippingCountries,
      isFetchingShippingMethods: false,
      fetchingShippingSuccess: true,
      fetchingShippingError: false,
      savingShippingSuccess: false,
      savingShippingError: false,
    };
  },
  [FetchShippingMethodError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => ({
    ...state,
    isFetchingShippingMethods: false,
    fetchingShippingSuccess: false,
    fetchingShippingError: true,
  }),
  [FetchShippingMethodsEnabled.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [FetchShippingMethodsEnabledSuccess.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [FetchShippingMethodsEnabledError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
  }),
  [SaveShippingCountries.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [SaveShippingCountriesSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [SaveShippingCountriesError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
  }),
  [SaveShippingMethodActive.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [SaveShippingMethodActiveSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [SaveShippingMethodActiveError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => {
    return {
      ...state,
      isSaving: false,
      savingShippingSuccess: false,
      savingShippingError: true,
      messageError: action.error,
    };
  },
  [ResetState.type]: (state: ShippingConfigState) => {
    return {
      ...state,
      isSaving: false,
      savingShippingSuccess: false,
      savingShippingError: false,
      flatRate: undefined,
      advancedRate: undefined,
      standardRate: undefined,
      locationsSelected: undefined,
      messageError: '',
    };
  },
  // FLAT RATE
  [FetchFlatRate.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    fetchingShippingSuccess: false,
    fetchingShippingError: false,
  }),
  [FetchFlatRateSuccess.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => {
    return {
      ...state,
      isSaving: false,
      fetchingShippingSuccess: true,
      fetchingShippingError: false,
      flatRate: action.flatRate,
    };
  },
  [FetchFlatRateError.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    fetchingShippingSuccess: false,
    fetchingShippingError: true,
  }),
  [SaveFlatRate.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [SaveFlatRateSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [SaveFlatRateError.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
  }),
  [EditFlatRate.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [EditFlatRateSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [EditFlatRateError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => {
    return {
      ...state,
      isSaving: false,
      savingShippingSuccess: false,
      savingShippingError: true,
      messageError: action.error,
    };
  },
  [DeleteFlatRate.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [DeleteFlatRateSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [DeleteFlatRateError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
    messageError: action.error,
  }),
  //SHIPPING ADVANCED
  [SaveLocationsSelected.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => {
    const {locationsSelected} = action;
    return {
      ...state,
      locationsSelected: {
        ...state.locationsSelected,
        ...locationsSelected.locationsSelected,
      },
    };
  },
  [SaveShippingAdvanced.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [SaveShippingAdvancedSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [SaveShippingAdvancedError.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
  }),
  [FetchShippingAdvanced.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    fetchingShippingSuccess: false,
    fetchingShippingError: false,
  }),
  [FetchShippingAdvancedSuccess.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => {
    return {
      ...state,
      isSaving: false,
      fetchingShippingSuccess: true,
      fetchingShippingError: false,
      advancedRate: action.shippingDataAdvanced,
    };
  },
  [FetchShippingAdvancedError.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    fetchingShippingSuccess: false,
    fetchingShippingError: true,
  }),
  [EditShippingAdvanced.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [EditShippingAdvancedSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [EditShippingAdvancedError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
    messageError: action.error,
  }),
  [DeleteShippingAdvanced.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [DeleteShippingAdvancedSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [DeleteShippingAdvancedError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
    messageError: action.error,
  }),
  [UpdateAllowOrderOutsideDeliveryZone.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [UpdateAllowOrderOutsideDeliveryZoneSuccess.type]: (
    state: ShippingConfigState
  ) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [UpdateAllowOrderOutsideDeliveryZoneError.type]: (
    state: ShippingConfigState
  ) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
  }),
  [ClearAllLocationsSelected.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => {
    const {countryCode} = action;
    const locationsSelected = state.locationsSelected;

    if (!locationsSelected) {
      return {
        ...state,
      };
    }

    const newLocationsSelected = Object.entries(locationsSelected)
      .filter(([key]) => key !== countryCode)
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});

    return {
      ...state,
      locationsSelected: Object.keys(newLocationsSelected).length
        ? newLocationsSelected
        : undefined,
    };
  },
  // SHIPPING STANDARD
  [SaveShippingStandard.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [SaveShippingStandardSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [SaveShippingStandardError.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
  }),
  [FetchShippingStandard.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    fetchingShippingSuccess: false,
    fetchingShippingError: false,
  }),
  [FetchShippingStandardSuccess.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => {
    return {
      ...state,
      isSaving: false,
      fetchingShippingSuccess: true,
      fetchingShippingError: false,
      standardRate: action.shippingDataStandard,
    };
  },
  [FetchShippingStandardError.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    fetchingShippingSuccess: false,
    fetchingShippingError: true,
  }),
  [EditShippingStandard.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [EditShippingStandardSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [EditShippingStandardError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: false,
    savingShippingError: true,
    messageError: action.error,
  }),
  [DeleteShippingStandard.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: true,
    savingShippingSuccess: false,
    savingShippingError: false,
  }),
  [DeleteShippingStandardSuccess.type]: (state: ShippingConfigState) => ({
    ...state,
    isSaving: false,
    savingShippingSuccess: true,
    savingShippingError: false,
  }),
  [DeleteShippingStandardError.type]: (
    state: ShippingConfigState,
    action: ShippingConfigAction
  ) => {
    return {
      ...state,
      isSaving: false,
      savingShippingSuccess: false,
      savingShippingError: true,
      messageError: action.error,
    };
  },
});

export function getLogisticShippingMethodEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(
      FetchShippingMethod.type,
      FetchShippingMethodsEnabledSuccess.type,
      SaveShippingCountriesSuccess.type,
      SaveShippingMethodActiveSuccess.type,
      SaveFlatRateSuccess.type,
      EditFlatRateSuccess.type,
      DeleteFlatRateSuccess.type,
      SaveShippingAdvancedSuccess.type,
      EditShippingAdvancedSuccess.type,
      DeleteShippingAdvancedSuccess.type,
      SaveShippingStandardSuccess.type,
      EditShippingStandardSuccess.type,
      DeleteShippingStandardSuccess.type,
      UpdateAllowOrderOutsideDeliveryZoneSuccess.type
    ),
    switchMap(() =>
      getShippingMethodApi().pipe(
        map(shippingMethods => {
          return new FetchShippingMethodSuccess({
            shippingMethods,
          });
        }),
        buildCatchError(FetchShippingMethodError)
      )
    )
  );
}

export function updateEnabledShippingMethodsEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(FetchShippingMethodsEnabled.type),
    switchMap(({enabled}: ShippingConfigAction) =>
      updatedShippingMethodEnabledApi({enabled}).pipe(
        map(() => new FetchShippingMethodsEnabledSuccess()),
        buildCatchError(FetchShippingMethodsEnabledError)
      )
    )
  );
}

export function saveCountriesEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(SaveShippingCountries.type),
    switchMap(({shippingCountries}: ShippingConfigAction) =>
      addShippingCountriesApi({shippingCountries}).pipe(
        map(() => new SaveShippingCountriesSuccess()),
        buildCatchError(SaveShippingCountriesError)
      )
    )
  );
}

export function saveActiveTypeRateEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(SaveShippingMethodActive.type),
    switchMap(({shippingMethodActive}: ShippingConfigAction) =>
      updateShippingMethodActiveApi(shippingMethodActive).pipe(
        map(() => new SaveShippingMethodActiveSuccess()),
        buildCatchError(SaveShippingMethodActiveError)
      )
    )
  );
}

// FLAT RATE
export function fetchFlatRateEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(FetchFlatRate.type),
    switchMap(({flatRateId}: ShippingConfigAction) =>
      getFlatRateApi(undefined, {
        route: buildRoute(endpoints.GET_FLAT_RATE, [flatRateId]),
      }).pipe(
        map(
          flatRate =>
            new FetchFlatRateSuccess({
              flatRate,
            })
        ),
        buildCatchError(FetchFlatRateError)
      )
    )
  );
}

export function saveFlatRateEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(SaveFlatRate.type),
    switchMap(({flatRate}: ShippingConfigAction) => {
      return saveFlatRateApi(flatRate).pipe(
        map(() => new SaveFlatRateSuccess()),
        buildCatchError(SaveFlatRateError)
      );
    })
  );
}

export function editFlatRateEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(EditFlatRate.type),
    switchMap(({flatRateId, flatRate}: ShippingConfigAction) => {
      return updateFlatRateApi(flatRate, {
        route: buildRoute(endpoints.UPDATE_FLAT_RATE, [flatRateId]),
      }).pipe(
        map(() => new EditFlatRateSuccess()),
        buildCatchError(EditFlatRateError)
      );
    })
  );
}

export function deleteFlatRateEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(DeleteFlatRate.type),
    switchMap(({flatRateId}: ShippingConfigAction) =>
      deleteFlatRateApi({
        route: buildRoute(endpoints.DELETE_FLAT_RATE, [flatRateId]),
      }).pipe(
        map(() => new DeleteFlatRateSuccess()),
        buildCatchError(DeleteFlatRateError)
      )
    )
  );
}

// SHIPPING ADVANCED
export function saveShippingAdvancedEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(SaveShippingAdvanced.type),
    switchMap(({advancedRate}: ShippingConfigAction) => {
      return saveShippingAdvancedApi(advancedRate).pipe(
        map(() => new SaveShippingAdvancedSuccess()),
        buildCatchError(SaveShippingAdvancedError)
      );
    })
  );
}

export function fetchShippingAdvancedEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(FetchShippingAdvanced.type),
    switchMap(({advancedRateId}: ShippingConfigAction) => {
      return getShippingAdvancedApi(undefined, {
        route: buildRoute(endpoints.GET_SHIPPING_ADVANCED, [advancedRateId]),
      }).pipe(
        map(
          shippingDataAdvanced =>
            new FetchShippingAdvancedSuccess({
              shippingDataAdvanced,
            })
        ),
        buildCatchError(FetchShippingAdvancedError)
      );
    })
  );
}

export function editShippingAdvancedEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(EditShippingAdvanced.type),
    switchMap(({advancedRateId, advancedRate}: ShippingConfigAction) => {
      return updateShippingAdvancedApi(advancedRate, {
        route: buildRoute(endpoints.UPDATE_SHIPPING_ADVANCED, [advancedRateId]),
      }).pipe(
        map(() => new EditShippingAdvancedSuccess()),
        buildCatchError(EditShippingAdvancedError)
      );
    })
  );
}

export function deleteShippingAdvancedEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(DeleteShippingAdvanced.type),
    switchMap(({advancedRateId}: ShippingConfigAction) =>
      deleteShippingAdvancedApi({
        route: buildRoute(endpoints.DELETE_SHIPPING_ADVANCED, [advancedRateId]),
      }).pipe(
        map(() => new DeleteShippingAdvancedSuccess()),
        buildCatchError(DeleteShippingAdvancedError)
      )
    )
  );
}

export function updateAllowOrderOutsideDeliveryZoneEpic(
  action$: ActionsObservable
) {
  return action$.pipe(
    ofType(UpdateAllowOrderOutsideDeliveryZone.type),
    switchMap(({allowOrdersOutsideDeliveryZone}: ShippingConfigAction) => {
      return updatedShippingMethodEnabledApi(
        allowOrdersOutsideDeliveryZone
      ).pipe(
        map(() => new UpdateAllowOrderOutsideDeliveryZoneSuccess()),
        buildCatchError(UpdateAllowOrderOutsideDeliveryZoneError)
      );
    })
  );
}

// SHIPPING STANDARD
export function saveShippingStandardEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(SaveShippingStandard.type),
    switchMap(({standardRate}: ShippingConfigAction) => {
      return saveShippingStandardApi(standardRate).pipe(
        map(() => new SaveShippingStandardSuccess()),
        buildCatchError(SaveShippingStandardError)
      );
    })
  );
}

export function fetchShippingStandardEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(FetchShippingStandard.type),
    switchMap(({standardRateId}: ShippingConfigAction) => {
      return getShippingStandardApi(undefined, {
        route: buildRoute(endpoints.GET_SHIPPING_STANDARD, [standardRateId]),
      }).pipe(
        map(
          shippingDataStandard =>
            new FetchShippingStandardSuccess({
              shippingDataStandard,
            })
        ),
        buildCatchError(FetchShippingStandardError)
      );
    })
  );
}

export function editShippingStandardEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(EditShippingStandard.type),
    switchMap(({standardRateId, standardRate}: ShippingConfigAction) => {
      return updateShippingStandardApi(standardRate, {
        route: buildRoute(endpoints.UPDATE_SHIPPING_STANDARD, [standardRateId]),
      }).pipe(
        map(() => new EditShippingStandardSuccess()),
        buildCatchError(EditShippingStandardError)
      );
    })
  );
}

export function deleteShippingStandardEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(DeleteShippingStandard.type),
    switchMap(({standardRateId}: ShippingConfigAction) => {
      return deleteShippingStandardApi({
        route: buildRoute(endpoints.DELETE_SHIPPING_STANDARD, [standardRateId]),
      }).pipe(
        map(() => new DeleteShippingStandardSuccess()),
        buildCatchError(DeleteShippingStandardError)
      );
    })
  );
}
